import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'ak',
    fullName: 'Akan',
    nativeName: 'Akan',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "ArgVoid na ɛyɛ adwuma",
    landing_title: "Biribi a Ɛyɛ Nwanwa Reba",
    landing_subtitle: "ArgVoid yɛ app ne agodie nkɔsoɔ studio. Twɛn, nneɛma foforo reba nnansa yi ara!",
    select_language: "Paw Kasa",
    search_placeholder: "Hwehwɛ kasa horow...",
    terms_title: "Ɔsom Ho Nhyehyɛe",
    policy_title: "Nsɛm a Wɔde Sie",
    cookies_title: "Kuki ho Mmara",
    terms_content: `
        <strong>1. Nsɛm a Wɔgye tom</strong><br>
        Sɛ wokɔ ArgVoid a, wogye Ɔsom Ho Mmara yi tom. Sɛ wɔannye saa nsɛm yi antom a, ɛnsɛ sɛ wɔde ɔsom no di dwuma.<br><br>

        <strong>2. Platform a Wɔde Di Dwuma</strong><br>
        Wɔde ArgVoid ne ne application ahorow ama "sɛnea ɛte" de ayɛ nsɛm ne adebɔ atirimpɔw ahorow. Ɛsɛ sɛ wɔde ɔsom no di dwuma ma mmara kwan so atirimpɔw ahorow nkutoo.<br><br>

        <strong>3. Abrabɔ a Wɔabara</strong><br>
        Wɔabara koraa sɛ wode sait no mu mmerɛwyɛ bedi dwuma, spamming, anaa abɔ mmɔden sɛ wobɛkɔ infrastructure no so a onni ho kwan.<br><br>

        <strong>4 na ɛwɔ hɔ. Nsɛm a Wɔka Kyerɛ</strong><br>
        Wobetumi asesa platform ne services no bere biara a wɔremmɔ amanneɛ. Wɔmfa warranty biara mma mfa bere a wɔde bɛyɛ adwuma anaa bere a wɔde bɛyɛ adwuma no ho.
    `,
    policy_content: `
        <strong>1. Nsɛm a Wɔaboaboa Ano</strong><br>
        Platform no nhia sɛ ɔde dwumadiefoɔ no di adanseɛ anaa ɔbɛbɔ akonta saa berɛ yi. Wɔnnye ankorankoro ho nsɛm biara (te sɛ edin anaa email address) mfi nsrahwɛfo hɔ denneennen.<br><br>

        <strong>2. Data a Wɔde Di Dwuma</strong><br>
        Wobetumi aboaboa mfitiaseɛ, anonymized analytics ano de ate site traffic ase na ama applications no atu mpɔn. Saa data yi ntumi nkɔ ankorankoro a wɔde di dwuma no ho.<br><br>

        <strong>3. Nnwuma a Ɛto so Abiɛsa</strong><br>
        Wobetumi de nnipa a wɔto so abiɛsa a wɔde ma no adi dwuma ama hosting ne analytics services. Saa dwumadie ahodoɔ yi kokoam nsɛm ho nneyɛeɛ na ɛkyerɛ data a wɔmmɔ din a wɔde di dwuma wɔ wɔn infrastructure so.<br><br>

        <strong>4 na ɛwɔ hɔ. Data Ahobammɔ</strong><br>
        Wɔde ahobammɔ ho nhyehyɛe a ntease wom di dwuma de bɔ asɛnka agua no ho ban. Nanso, ɔkwan biara nni hɔ a wɔfa so de nsɛm kɔ Intanɛt so a ahobammɔ wom koraa.<br><br>
    `,
    cookies_content: `
        <strong>1. Dɛn ne Kuki ne Mpɔtam Hɔ Storage?</strong><br>
        Kuki ne browser local storage yɛ data fael nketewa a wɔde asie wɔ afiri no so de kae nhyehyɛe a wɔpɛ wɔ nsrahwɛ ahorow nyinaa mu.<br><br>

        <strong>2. Botae a Wɔde Di Dwuma</strong><br>
        Wɔde Browser LocalStorage di dwuma katee de sie nhyehyɛe nhyehyɛe, te sɛ:<br>
        - kasa a wopaw<br>
        - dwumadie nhyehyeε (e.g., nhyehyeε anaa asɛmti nhyehyeε)<br>
        - bere tiaa mu dwumadie cache<br><br>

        <strong>3 na ɛwɔ hɔ. No Tracking</strong><br> na ɛwɔ hɔ
        Wɔmfa cookies ne mpɔtam hɔ nneɛma a wɔkora so nni dwuma mfa nyɛ aguade ho dawurubɔ anaasɛ wɔmfa nni dwuma mfa nni dwuma wɔ nnipa foforo akyi. Data a wɔakora so nyinaa yɛ katee ma platform no dwumadi titiriw.<br><br>

        <strong>4 na ɛwɔ hɔ. Nkonimdi</strong><br>
        Wobetumi asiesie browser data bere biara denam browser nhyehyɛe no so, a ɛbɛsan asiesie mpɔtam hɔ nhyehyɛe biara.
    `,
    cookie_consent_text: "Yɛde cookies titiriw di dwuma de hwɛ hu sɛ wɛbsaet no yɛ adwuma yiye, te sɛ wo nhyiam no a yɛbɛma ayɛ adwuma, kasa a wopɛ a wode besie, ne nhyehyɛe afoforo a wopɛ.",
    read_policy: "Kenkan Kuki ho Mmara",
    support_title: "Wo ne Mmoa no nni nkitaho",
    support_subject_label: "Adesuadeɛ",
    support_message_label: "Nkratoɔ",
    support_submit_button: "Send Nkrasɛm",
    support_hint: "Hyɛ no nsow: Eyi bebue wo default email application no na wode nkra no amena.",
    support_success_msg: "Worebue wo email app no...",
    support_error_msg: "Entumi mfa nkra nkɔma. Yɛsrɛ sɛ sɔ hwɛ bio akyiri yi.",
    explorer_title: "Explorer",
    history_title: "Abakɔsɛm",
    animation_title: "Animation a wɔde yɛ nneɛma",
    config_title: "Nsiesiei a Wɔde Yɛ Adwuma",
    tool_mouse: "Paw (Ctrl+M) .",
    tool_brush: "Brush (Ctrl + B) a wɔde hyɛ mu.",
    tool_brush_mode: "Toggle Mode (Nea Ɛyɛ Den/Nea Ɛda Hɔ) .",
    tool_eraser: "Nneɛma a wɔde popa nneɛma (Ctrl+E) .",
    tool_brush_size: "Sesa Brush Kɛseɛ",
    tool_bucket: "Hyɛ no ma (Ctrl+F) .",
    tool_eyedropper: "Eyedropper",
    tool_grid: "Grid (Ctrl + Nsakrae + B) .",
    tool_rotate: "Di akɔneaba (Ctrl + Shift + R) .",
    tool_flip_h: "Flip H (Ctrl + Nsakrae + H) .",
    tool_flip_v: "Flip V (Ctrl + Nsakrae + V) .",
    tool_transpose: "Transpose (Ctrl + Nsakrae + T) .",
    label_width: "Ntrɛmu",
    label_height: "Tenten",
    label_frames: "Frames Dodow a Wɔde Di Dwuma",
    label_animation: "Animation Style a Wɔde Yɛ Nneɛma",
    label_background_color: "Akyi Kɔla",
    label_interval: "Ntamgyinafo",
    tool_anim_config: "Animation Nsiesiei a Wɔde Yɛ Adwuma",
    label_new_width: "Ntrɛwmu Foforo",
    label_new_height: "Ɔsorokɔ Foforo",
    label_apply: "Pere",
    label_colors: "Kɔla ahorow",
    label_size: "Kɛseɛ",
    label_tolerance: "Nsosɔsoɔ",
    val_horizontal: "Ne tɛtrɛtɛ mu",
    val_vertical: "Tenten mu",
    val_sequence: "Ntoasoɔ",
    val_bounce: "Huri",
    val_random: "Toto sisi",
    val_solid: "Mua",
    val_clear: "Wann",
    action_add_sheet: "Krataa Foforo",
    action_import: "Kra bra",
    action_export: "Mane kɔ",
    action_sort_projects: "Yiyi mu",
    sort_date_old: "Nea Akyɛ sen biara Nea edi kan",
    sort_date_new: "Nea Ɛyɛ Foforo Nea Edi Kan",
    sort_name_az: "Edin (A-Z) .",
    sort_name_za: "Edin (Z-A) .",
    action_new_sprite: "Sprite Foforo",
    action_new_project: "Dwumadi Foforo",
    modal_save_all_title: "Sie Nsakrae Nyinaa",
    modal_save_all_desc: "Paw agyapade a wode besie:",
    modal_save_selected: "Fa Sie a Wɔapaw",
    action_saved: "Wɔakora so",
    modal_create_sprite_title: "Yɛ Sprite Foforo",
    modal_create_project_title: "Yɛ Dwumadi Foforo",
    modal_add_sheet_title: "Fa Krataa Foforo Ka Ho",
    modal_rename_sheet_title: "Sesa Din Krataa no",
    modal_rename_sprite_title: "Sesa din foforo Sprite",
    modal_delete_sprite_title: "Popa Sprite no",
    modal_delete_project_title: "Popa Dwumadi no",
    modal_delete_sheet_title: "Popa Krataa no",
    placeholder_sprite_name: "Din",
    placeholder_project_name: "Din",
    placeholder_sheet_name: "Din",
    placeholder_new_name: "Edin Foforo",
    action_create: "Yɛ",
    action_add: "Fa ka ho",
    action_rename: "Sesa din foforo",
    action_duplicate: "Yɛ nea wɔayɛ no abien",
    action_delete: "Pepa",
    action_cancel: "Twam",
    confirm_delete_sprite: "Wogye di sɛ wopɛ sɛ wopopa saa sprite yi?",
    confirm_delete_project: "So wugye di sɛ wopɛ sɛ wopopa saa adwuma yi? Wɔbɛyi sprites nyinaa afiri hɔ.",
    confirm_delete_sheet: "So wugye di sɛ wopɛ sɛ wopopa krataa yi?",
    err_select_sprite: "Yɛsrɛ sɛ di kan paw sprite bi.",
    err_select_project: "Yɛsrɛ sɛ di kan paw adwuma bi.",
    err_name_empty: "Edin ntumi nyɛ hunu.",
    err_sprite_exists: "Sprite a ɛwɔ saa din no wɔ hɔ dedaw.",
    err_project_exists: "Dwumadi bi a ɛwɔ saa din no wɔ hɔ dedaw.",
    err_no_content: "Nsɛm biara nni hɔ a ɛsɛ sɛ wode sie.",
    err_no_changes: "Nsakrae biara nni hɔ a ɛsɛ sɛ wode sie.",
    err_delete_last_sheet: "Wontumi mpopa krataa a etwa to no.",
    err_extract_frames: "Entumi nnyi frame biara mfi mu.",
    err_indexeddb: "Entumi nkora so wɔ mpɔtam hɔ. Ebia wo browser no rentumi mmoa IndexedDB.",
    msg_upload_success: "Upload no adi nkonim: {0}",
    msg_upload_failed: "Upload no adi nkogu: {0}",
    msg_save_success: "Save nkonimdi.",
    msg_saving: "Sikakorabea...",
    msg_multi_save_result: "Wɔakora {0} agyapadeɛ so. {1} huammɔdi ahorow.",
    menu_title: "Menu a wɔde ma",
    menu_save: "Kora",
    menu_save_all: "Sie Ne Nyinaa",
    menu_support: "Wo ne Mmoa no nni nkitaho",
    label_local_storage: "Mpɔtam Hɔ Nneɛma a Wɔkora So",
    label_sign_in: "Hyehyɛ Mu",
    modal_export_title: "Fa Sprite kɔ amannɔne",
    label_filename: "Fael din",
    label_format: "Ɔkwan a wɔfa so yɛ no",
    action_export_confirm: "Mane kɔ",
};

export default translations;
